import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { useState } from 'react'

import IconButton from '@/components/IconButton'
import SendEmailSidebar from '@/components/SendEmail'

export interface Props {
  customerId: string
  applicationId: string
  subjectId: string
  subjectType: string
}

const SendEmailAction = ({
  customerId,
  applicationId,
  subjectId,
  subjectType,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <IconButton
        ariaLabel="Send email"
        tooltipMessage={`Send ${subjectType} emails`}
        icon={faEnvelope}
        onClick={() => setIsOpen(true)}
      />
      {isOpen && (
        <SendEmailSidebar
          testId="send-email-sidebar"
          customerId={customerId}
          applicationId={applicationId}
          subjectId={subjectId}
          subjectType={subjectType}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}

export default SendEmailAction
